import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const DescriptionModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: t(`Description`) }} />
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{
                    __html: t(`The description gives a little more explanation or context 
                    for your status designation. Eg. You've proven yourself adept with potions.`)
                }} />
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t(`Close`)}
                </Button>
            </div>
        </Modal>
    )
};

export default DescriptionModal;
